import {map} from 'lodash';
import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';

import {Accordion, AccordionDetails, AccordionTitle, TranslationLanguageSelector} from 'components';
import {AgentSession, AnyParticipant} from 'interfaces';
import {TRANSLATION_KEYS} from 'locale';
import {ParticipantTranslationSettings, TranslationSettings as TranslationSettingsType} from 'types';

import {UserSessionParticipant} from '../UserSessionParticipant';

const T_KEYS = TRANSLATION_KEYS.IN_SESSION_PAGE.TRANSCRIPTIONS_SIDEBAR.SETTINGS;

type Props = {
    session: AgentSession;
    settings: TranslationSettingsType;
    disabled?: boolean;
    className?: string;
    includeLanguages?: string[];
    onChange: (data: TranslationSettingsType) => void;
}

export const TranslationSettings: React.FC<Props> = ({session, settings, disabled, includeLanguages, onChange}) => {
    const {t} = useTranslation();

    const getParticipantLanguage = useCallback((participant: AnyParticipant) =>
        settings?.[participant.id]?.language || '',
    [settings]);

    const handleSettingsChange = useCallback((participant: AnyParticipant, updatedSettings: ParticipantTranslationSettings) => {
        const updates = {
            [participant.id]: updatedSettings
        };

        onChange(updates);
    }, [onChange]);

    return (
        <Accordion shadow={false} padding={false}>
            <AccordionTitle styled={false}>
                <div className='tw-ml-2'>
                    {t(T_KEYS.TITLE)}
                </div>
            </AccordionTitle>
            <AccordionDetails>
                <div className='tw-grid tw-gap-4'>
                    <div>
                        <UserSessionParticipant session={session} participant={session.localParticipant} local fields={{}} />
                        <TranslationLanguageSelector
                            value={getParticipantLanguage(session.localParticipant)}
                            include={includeLanguages}
                            disabled={disabled}
                            placeholder={t(T_KEYS.LANGUAGE.LABEL)}
                            onChange={(language) => handleSettingsChange(session.localParticipant, {language})}
                        />
                    </div>
                    {map(session.participants, (p) => (
                        <div key={p.id}>
                            <UserSessionParticipant
                                session={session}
                                participant={p}
                                fields={{}}
                            />
                            <TranslationLanguageSelector
                                value={getParticipantLanguage(p)}
                                include={includeLanguages}
                                placeholder={t(T_KEYS.LANGUAGE.LABEL)}
                                disabled={disabled}
                                onChange={(language) => handleSettingsChange(p, {language})}
                            />
                        </div>
                    ))}
                </div>
            </AccordionDetails>
        </Accordion>
    );
};